import { combineReducers } from 'redux';
import toastReducer from '../../components/toast/toast-reducer';
import modalContainerReducer from '../modal-manager/modal-manager-reducer';
import assignLaterReducer from '../../components/assign-later/store/assign-later.reducer';
import CourseAssignReducer from '../course-assign/course-assign-reducer';
import unassignModalReducer from '../../components/unassign-all-modal/store/unassign-all-modal.reducer';

const CombinedReducers = combineReducers({
  product: (state) => ({ ...state }),
  toastReducer,
  assignLaterReducer,
  modalContainerReducer,
  unassignModalReducer,
  CourseAssignReducer
});

export default CombinedReducers;



// WEBPACK FOOTER //
// ./containers/app/combined-reducers.js